import type { ApplicantStage } from '@/types/portal';

const STORAGE_KEY = 'twiva.applicantStages.v1';

/** Local review overrides, keyed by applicant id. */
export type ApplicantStageMap = Record<string, ApplicantStage>;

/** Read every local applicant stage override. */
export function loadApplicantStages(): ApplicantStageMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as ApplicantStageMap;
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed;
  } catch {
    return {};
  }
}

/** Persist the stage overrides; degrades quietly if storage is blocked. */
export function persistApplicantStages(map: ApplicantStageMap): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // Storage unavailable (private mode) — the session keeps the in-memory copy.
  }
}